export const urlParams = {
  projectId: '{projectId}',
  itemId: '{itemId}',
  version: '{version}',
};

const ITEM_DETAILS_PAGE_PATH =
  '/build/submittals/projects/{projectId}/items/{itemId}';

export function generateSubmittalItemLink(
  projectId: string,
  itemId: string,
): string {
  const origin = window.location.origin;

  return (
    origin +
    ITEM_DETAILS_PAGE_PATH.replace(urlParams.projectId, projectId).replace(
      urlParams.itemId,
      itemId,
    )
  );
}
